import { AppState } from 'Store'

const getAll = (state: AppState) => state.coliseum.block.block
const getEntries = (state: AppState) => state.coliseum.block.block.entries
const getAllTotal = (state: AppState) => state.coliseum.block.block.total_entries
const getRequestParams = (state: AppState) => state.coliseum.block.requestParams

export const blockSelectors = {
	getAll,
	getEntries,
	getAllTotal,
	getRequestParams,
}
